export default __webpack_public_path__ + "static/Litepaper - Russian-0c2da1c77c8d7f79c627d5134d188ff8.pdf";